import axios from "axios";
import { Message } from "element-ui";
import { Toast } from "vant";
const errorTips = msg => {
  if (
    navigator.userAgent.indexOf("IEMobile") !== -1 ||
    window.innerWidth < 1200
  ) {
    Toast.fail(msg);
  } else {
    Message.error(msg);
  }
};

axios.interceptors.request.use(
  config => {
    // 在请求头中添加自定义字段 lang
    config.headers["lang"] =
      localStorage.getItem("lang") === "en" ? "EN" : "zh-CN"; // 你可以根据需要设置不同的语言值
    return config;
  },
  error => {
    // 处理请求错误
    return Promise.reject(error);
  }
);
const getList = () => {
  return axios
    .post(
      "/api/v1/llm-user/experienceHall/secondLevelShowroom/submit/customerInfo",
      { secondLevelAlgorithmId: "0" }
    )
    .then(res => {
      if (res.data.Code !== 0) {
        errorTips(res.data.Msg);
      } else {
        return res.data;
      }
    })
    .catch(() => {});
};
const make = data => {
  return axios
    .post(
      "/api/v1/llm-user/experienceHall/secondLevelAlgorithms/calculate",
      data
    )
    .then(res => {
      if (res.data.Code !== 0) {
        errorTips(res.data.Msg);
      } else {
        return res.data;
      }
    });
};
const getExample = data => {
  return axios
    .post("/api/v1/llm-user/experienceHall/AigcPicture/example", data)
    .then(res => {
      if (res.data.Code !== 0) {
        errorTips(res.data.Msg);
      } else {
        return res.data;
      }
    });
};
const getAdj = () => {
  return axios
    .get("/api/v1/llm-user/experienceHall/AigcPicture/promptList")
    .then(res => {
      if (res.data.Code !== 0) {
        errorTips(res.data.Msg);
      } else {
        return res.data;
      }
    });
};
const showroomCase = () => {
  return axios
    .get("/api/v1/llm-user/experienceHall/firstLevelShowroom/case")
    .then(res => {
      if (res.data.Code !== 0) {
        errorTips(res.data.Msg);
      } else {
        return res.data;
      }
    });
};
const getFirstLevelShowroom = () => {
  return axios
    .get("/api/v1/llm-user/experienceHall/firstLevelShowroom")
    .then(res => {
      if (res.data.Code !== 0) {
        errorTips(res.data.Msg);
      } else {
        return res.data;
      }
    });
};
const secondLevelShowroom = data => {
  return axios
    .post("/api/v1/llm-user/experienceHall/secondLevelShowroom", data)
    .then(res => {
      if (res.data.Code !== 0) {
        errorTips(res.data.Msg);
      } else {
        return res.data;
      }
    });
};
const showroomDetail = id => {
  return axios
    .get(`/api/v1/llm-user/experienceHall/secondLevelShowroom/detail/${id}`)
    .then(res => {
      if (res.data.Code !== 0) {
        errorTips(res.data.Msg);
      } else {
        return res.data;
      }
    });
};
const customerInfo = data => {
  return axios
    .post(
      "/api/v1/llm-user/experienceHall/secondLevelShowroom/submit/customerInfo",
      data
    )
    .then(res => {
      if (res.data.Code !== 0) {
        errorTips(res.data.Msg);
      } else {
        return res.data;
      }
    });
};
const getFooterHeader = () => {
  return axios
    .get(
      `/websiteHtml/html/get-header-footer-html.html?locale=${
        localStorage.getItem("lang") === "en" ? "EN" : "CN"
      }&type=mobile&isGuest=true&serviceDomain=&active=`
    )
    .then(res => {
      return res.data;
    });
};
//'https://sophon.cn'+
export default {
  getList,
  make,
  getExample,
  getAdj,
  showroomCase,
  getFirstLevelShowroom,
  secondLevelShowroom,
  showroomDetail,
  customerInfo,
  getFooterHeader,
};
